import { useState } from "react";
import { Clock } from "lucide-react";
import { cn } from "../../lib/cn";
import { formatTimeDisplay } from "../../utils/timeFormat";
import { inputStyles } from "./Input";
import { usePopoverId } from "./Popover";
import { DropdownPortal, useDropdownPanel } from "./useDropdownPanel";
import { TimeSelector } from "./TimeSelector";

export function TimePicker({
  value = "09:00",
  onChange,
  disabled = false,
  className,
}) {
  const panelId = usePopoverId();
  const [open, setOpen] = useState(false);
  const { triggerRef, panelRef, position } = useDropdownPanel(open, setOpen);

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        id={panelId}
        aria-haspopup="dialog"
        aria-expanded={open}
        disabled={disabled}
        onClick={() => !disabled && setOpen((v) => !v)}
        className={cn(
          inputStyles,
          "flex w-full items-center justify-between gap-2 text-left cursor-pointer",
          open && "ring-2 ring-ring border-transparent",
          disabled && "cursor-not-allowed",
          className,
        )}
      >
        <span>{formatTimeDisplay(value)}</span>
        <Clock size={16} className="shrink-0 text-muted-foreground" />
      </button>

      {open && (
        <DropdownPortal>
          <div
            ref={panelRef}
            data-picker-dropdown
            role="dialog"
            aria-labelledby={panelId}
            onMouseDown={(e) => e.stopPropagation()}
            style={{
              position: "fixed",
              top: position.top,
              left: position.left,
              width: Math.max(position.width, 228),
              zIndex: 100,
            }}
            className="rounded-xl border border-border bg-card p-3 shadow-lg"
          >
            <TimeSelector
              value={value}
              disabled={disabled}
              onChange={onChange}
              className="border-0 shadow-none"
            />
          </div>
        </DropdownPortal>
      )}
    </>
  );
}
